import { useCreate, useDelete, useOne } from '@refinedev/core';

const RESOURCE = 'orders';

export const useShippingService = () => {
  const { mutate: createMutate, isLoading: loadingCreate } = useCreate();

  async function shippingPrice(payload: CalculateParcelPricePayload): Promise<any> {
    return new Promise((resolve, reject) => {
      createMutate({
        resource: 'shipping-costs',
        values: payload,
        dataProviderName: 'masterdata',
      }, {
        onSuccess: (response) => resolve(response),
        onError: (error) => reject(error),
      });
    });
  }

  return {
    loadingCreate,
    shippingPrice,
  };
};

export default useShippingService;
